import { render, staticRenderFns } from "./FamilyListing.vue?vue&type=template&id=0cd28584&scoped=true&lang=pug&"
import script from "./FamilyListing.vue?vue&type=script&lang=js&"
export * from "./FamilyListing.vue?vue&type=script&lang=js&"
import style0 from "./FamilyListing.vue?vue&type=style&index=0&id=0cd28584&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cd28584",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VCard,VIcon,VSimpleTable,VSkeletonLoader})
